import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { loadMessages } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import { versionJson } from '../current.build';
import { MyOidcAuthService } from './my-oidc-auth.service';


loadMessages(deMessages);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
export class AppComponent implements OnInit {

  public readonly version = versionJson.version;

  constructor(
    readonly translate: TranslateService,
    private readonly authService: MyOidcAuthService) {
    this.authService.runInitialLoginSequence();
  }


  async ngOnInit() {
  }
}
